import {
  FaSuperpowers,
  FaRegLightbulb,
  FaDiceD20,
} from "@onemind-services-llc/react-icons-ng/fa";

export const VISION_MISSION_LIST = [
  {
    content:
      "Our mission: Pioneer breakthroughs to make every aspect, from inception to cloud, practical and accessible.",
    icon: FaSuperpowers,
    title: "Mission",
  },
  {
    content:
      "Innovation sets leaders apart from followers, per Steve Jobs. We infuse innovation into your business, setting you apart, accelerating growth, optimizing investments, and achieving your goals.",
    icon: FaRegLightbulb,
    title: "Innovation",
  },
  {
    content:
      "In the fast-evolving tech landscape, outdated processes lag behind. Modern businesses demand agile IT to meet current needs. We aim to pioneer breakthroughs, making technology accessible from start to cloud.",
    icon: FaDiceD20,
    title: "Next Get Technology",
  },
];
